"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProjectCard = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _designSystem = require("@storybook/design-system");

var _theming = require("@storybook/theming");

var _NormalizeArea = require("../NormalizeArea");

var _LinkCard = require("./LinkCard");

var _excluded = ["accentColor", "height", "width", "logoAlt", "logoUrl", "name", "onClick", "projectUrl", "size", "idealArea"];

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }

var Logotype = (0, _theming.styled)("span", process.env.NODE_ENV === "production" ? {
  target: "e1r3u0qr1"
} : {
  target: "e1r3u0qr1",
  label: "Logotype"
})("font-size:", function (props) {
  return props.size === 'jumbo' ? _designSystem.styles.typography.size.l2 : _designSystem.styles.typography.size.m2;
}, "px;font-weight:", _designSystem.styles.typography.weight.black, ";");

var _ref = process.env.NODE_ENV === "production" ? {
  name: "1opa8gd",
  styles: "img{max-width:120px;object-fit:contain;}"
} : {
  name: "uju6gk-Thumb",
  styles: "img{max-width:120px;object-fit:contain;};label:Thumb;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};

var Thumb = (0, _theming.styled)("div", process.env.NODE_ENV === "production" ? {
  target: "e1r3u0qr0"
} : {
  target: "e1r3u0qr0",
  label: "Thumb"
})("align-items:center;color:", _designSystem.styles.color.lightest, ";display:flex;flex-direction:column;font-size:", function (props) {
  return props.size === 'jumbo' ? "".concat(_designSystem.styles.typography.size.m2, "px") : 'inherit';
}, ";font-weight:", _designSystem.styles.typography.weight.bold, ";gap:15px;justify-content:center;padding:10px 20px 0;text-align:center;img{filter:brightness(0) invert(1);}", function (props) {
  return !props.shouldNormalizeArea && _ref;
}, ";");

var ProjectCard = function ProjectCard(_ref2) {
  var accentColor = _ref2.accentColor,
      height = _ref2.height,
      width = _ref2.width,
      logoAlt = _ref2.logoAlt,
      logoUrl = _ref2.logoUrl,
      name = _ref2.name,
      onClick = _ref2.onClick,
      projectUrl = _ref2.projectUrl,
      _ref2$size = _ref2.size,
      size = _ref2$size === void 0 ? 'regular' : _ref2$size,
      _ref2$idealArea = _ref2.idealArea,
      idealArea = _ref2$idealArea === void 0 ? size === 'jumbo' ? 40000 : 11000 : _ref2$idealArea,
      restProps = (0, _objectWithoutProperties2["default"])(_ref2, _excluded);
  var image = logoUrl ? /*#__PURE__*/_react["default"].createElement("img", {
    src: logoUrl,
    alt: logoAlt,
    loading: "lazy"
  }) : /*#__PURE__*/_react["default"].createElement(Logotype, {
    size: size
  }, logoAlt);
  var shouldNormalizeArea = Boolean(logoUrl && height && idealArea && width);

  if (shouldNormalizeArea) {
    image = /*#__PURE__*/_react["default"].createElement(_NormalizeArea.NormalizeArea, {
      height: height,
      idealArea: idealArea,
      width: width
    }, image);
  }

  return /*#__PURE__*/_react["default"].createElement(_LinkCard.LinkCard, (0, _extends2["default"])({
    backgroundColor: accentColor.hex,
    href: projectUrl
  }, restProps), /*#__PURE__*/_react["default"].createElement(Thumb, {
    shouldNormalizeArea: shouldNormalizeArea,
    size: size
  }, image, name));
};

exports.ProjectCard = ProjectCard;